/** @jsxImportSource @emotion/react */
import { formatCurrency } from '@quickbit/backoffice-core-frontend';
import { Input, MoneyScaled } from '@quickbit/qb-design-system';
import { getLabel } from 'tabs/AppUsers/types';
import { Destination, MaskedCreditCard } from './api';

type TransactionFieldType =
  | 'money'
  | 'string'
  | 'destination'
  | 'paymentMethod';

interface Props {
  name: string;
  value: any;
}

export const TransactionItem = ({ name, value }: Props) => {
  if (!value) return null;
  let fieldType: TransactionFieldType = 'string';
  if (
    typeof value === 'object' &&
    ['amount', 'currencyCode', 'scale'].every((k) =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.keys(value).includes(k)
    )
  ) {
    fieldType = 'money';
  } else if (typeof value === 'object' && 'address' in value) {
    fieldType = 'destination';
  } else if (typeof value === 'object' && 'cardBrand' in value) {
    fieldType = 'paymentMethod';
  }

  let stringValue = '';
  switch (fieldType) {
    case 'string': {
      stringValue = value as string;
      break;
    }
    case 'money': {
      stringValue = formatCurrency(value as MoneyScaled);
      break;
    }
    case 'destination': {
      const destination = value as Destination;
      if (destination.type === 'MERCHANT') {
        stringValue = `MERCHANT: ${destination.merchant?.name}, ORDER ID: ${destination.merchant?.orderId}`;
      } else {
        stringValue = destination.user?.firstName
          ? `${destination.user.firstName} ${destination.user.lastName}`
          : destination.address;
      }
      break;
    }
    case 'paymentMethod': {
      stringValue = `${(value as MaskedCreditCard).type} ${
        (value as MaskedCreditCard).cardNumberLastDigits
          ? `(XXXX-XXXX-XXXX-${
              (value as MaskedCreditCard).cardNumberLastDigits
            })`
          : ''
      }`;
      break;
    }
  }
  return (
    <Input label={getLabel(name)} value={stringValue} onChange={() => ({})} />
  );
};
